import apiWrapper from '../apiWrapprer'

const endpoints = {
  getListDataById: '/frontend/webMethods/Statistics.asmx/GetListDataById'
}

export const getListDataById = (idList, guid) => {

  const url = endpoints.getListDataById
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({
      idList,
      guid
    })
  }).then(extractData)
}

const extractData = ({ data }) => JSON.parse(data.d)

export const isFrontendError = (result) => {
  return (result.$types && Object.keys(result.$types)[0].split(',').map(k => k.trim()).includes('mailUp.lib.FrontendException')) ||
  (result.$type && (result.$type.match(/mailUp\.lib\.FrontendException/) !== null))
}
